import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Users from './pages/Users';
import UsersList from './pages/UsersList';
import Dashboard from './components/Dashboard';
import Analytics from './pages/Analytics';
import PatientOverview from './pages/PatientOverview';
import MyAccount from './pages/MyAccount';
import Settings from './pages/Settings';
import Administration from './pages/Administration';
import Appointments from './pages/Appointments';
import Notes from './pages/Notes';
import Alerts from './pages/Alerts';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Layout>
            <Routes>
              <Route path="/" element={<Users />} />
              <Route path="/overview" element={<Users />} />
              <Route path="/users" element={<UsersList />} />
              <Route path="/patient/:patientId" element={<Dashboard />} />
              <Route path="/analytics/:type" element={<Analytics />} />
              <Route path="/patient-overview" element={<PatientOverview />} />
              <Route path="/appointments" element={<Appointments />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/my-account" element={<MyAccount />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/administration" element={<Administration />} />
            </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
